export default __webpack_public_path__ + "static/media/DeclaraciondeResidenciaGruposConformados2025_invitacionpublica.28647f1f.docx";